$(function () {
  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('is-active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function (e) {
    if ($(window).width() <= 1170) {
      if ($(this).hasClass('mobile-cate-show')) {
        e.preventDefault();
      }
      if ($(this).parent('.header-menu-link').hasClass('is-active')) {
        $(this).siblings('.header-menu-dropdown').slideUp(300);
        setTimeout(() => {
          $(this).parent('.header-menu-link').removeClass('is-active');
        }, 300);
      } else {
        $(this).parent('.header-menu-link').addClass('is-active');
        $(this).siblings('.header-menu-dropdown').slideDown(300);
      }
    }
  });
  $(".header-menu-link").hover(function () {
    if ($(window).width() > 1170) {
      var isHovered = $(this).is(":hover");
      if (isHovered) {
        $(this).children('.header-menu-dropdown').stop().slideDown(300);
      } else {
        $(this).children('.header-menu-dropdown').stop().slideUp(300);
      }
    }
  });

  $(window).resize(function () {
    if ($(window).width() > 1170) {
      $('.header-menu-dropdown').slideUp(300);
      $('.header-menu-link').removeClass('is-active');
    }
  });

  var headerDropdownCate = $('.header-menu-dropdown .dropdown-cate');

  headerDropdownCate.on('mouseenter', function () {
    var cateID = $(this).data('id');
    var cateContent = $('.dropdown-cate-items[data-content=' + cateID + ']');
    cateContent.addClass('is-active').siblings().removeClass('is-active');
    var itemImg = cateContent.find('.dropdown-cate-item').first().data('img');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $(this).parent().siblings('.dropdown-cate-item-img').find('img').attr("src", itemImg);
  });

  $('.header-menu-dropdown').each(function () {
    $(this).find('.dropdown-cate').first().trigger('mouseenter');
  });
});
